var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modalCertificado",attrs:{"titulo":_vm.titulo,"no-aceptar":"","no-cancelar":"","tamano":"modal-lg"}},[_c('div',{staticClass:"row mx-0 justify-center"},[_c('div',{staticClass:"col-auto"},[_c('img',{staticClass:"obj-cover",staticStyle:{"max-width":"395px","max-height":"100%"},attrs:{"src":_vm.img}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }